(() => {
  if (window.sfProductInfoInitialized) return;
  window.sfProductInfoInitialized = true;
  const applyPreviewDesign = () => {
    const design = new URLSearchParams(window.location.search).get('sf_buybox_design');
    if (design !== 'original' && design !== 'premium') return;
    document.querySelectorAll('.sf-pi[data-sf-preview="true"]').forEach(block => {
      block.dataset.sfDesign = design;
    });
  };
  applyPreviewDesign();
  document.addEventListener('shopify:section:load', applyPreviewDesign);
  const refresh = ({data}) => {
    if (!data?.html || !data.sectionId) return;
    const root = document.getElementById(`ProductInfo-${data.sectionId}`);
    if (!root) return;
    root.querySelectorAll('[data-sf-inventory]').forEach(current => {
      const block = current.closest('.sf-pi');
      const next = data.html.getElementById(block.id);
      if (next) {
        const replacement = next.cloneNode(true);
        replacement.dataset.sfDesign = block.dataset.sfDesign;
        block.replaceWith(replacement);
      }
    });
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, refresh);
  }
})();
